var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Outline",
    viewBox: "0 0 24 24",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "         M22.766,         4.566A1.994,         1.994,         0,         0,         0,         20.586,         5L18,         7.586,         13.414,         3a2,         2,         0,         0,         0-2.828,         0L6,         7.586,         3.414,         5A2,         2,         0,         0,         0,         0,         6.414V17a5.006,         5.006,         0,         0,         0,         5,         5H19a5.006,         5.006,         0,         0,         0,         5-5V6.414A2,         2,         0,         0,         0,         22.766,         4.566ZM22,         17a3,         3,         0,         0,         1-3,         3H5a3,         3,         0,         0,         1-3-3V6.414L5.293,         9.707a1,         1,         0,         0,         0,         1.414,         0L12,         4.414l5.293,         5.293a1,         1,         0,         0,         0,         1.414,         0L22,         6.414Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.a25b0cb0c2e7beaed18f36d85887ee54.svg";
export { ForwardRef as ReactComponent };